"use strict";

import {translate} from '@elements/translations';
import {loadParsley} from "@elements/parsley-bootstrap-validation";
import {trackEvent} from "./trackingGa4/gtm";
import {getPrefixedDataSet} from "@elements/data-set-utils"

export function initInScope($scope) {
    let $containers = $scope.find('.js-check-address');
    let useAnyway = localStorage.getItem('useAnyway') === 'true';
   // console.log('useAnyway', useAnyway);

    $containers.each(function () {
        let $container = $(this);
        let pendingRequest = null;
        let pendingRequestAddress = null;
        let $addressInput = $container.find('.js-check-address__input');

        $addressInput.on({
            change: function() {
                validate(this);
            },
            input: function() {
                if(localStorage.getItem('useAnyway') === 'true' ){
                    localStorage.setItem('useAnyway', 'false');
                }
            }
        });

        $addressInput.each(function () {
            if ($(this).val()) {
                validate(this);
            }
        });

        function validate(input) {
            if (localStorage.getItem('useAnyway') === 'false' || localStorage.getItem('useAnyway') === null) {
                console.log('validate');
                loadParsley().then(function () {
                    let $container = $(input).closest('.js-check-address');
                    let $submitBtn = $(input).closest('form').find('button[type=submit]');
                    let $zip = $container.find('.js-check-address__zip');
                    let $country = $container.find('.js-check-address__country');
                    let $street = $container.find('.js-check-address__street');
                    let $number = $container.find('.js-check-address__number');
                    let $city = $container.find('.js-check-address__city');

                    if ($submitBtn.length > 0) {
                        console.log($submitBtn);
                    } else {
                        let formId = $(input).closest('form').attr('id');
                        $submitBtn = $('button[form=' + formId + ']');
                    }

                    //validate address with shipXPert
                    if ($zip.val() !== '' && $country.val() !== null && $city.val() !== '' && $street.val() !== '') {
                        if (pendingRequestAddress) {
                            pendingRequestAddress.abort();
                            pendingRequestAddress = null;
                        }

                        let ajaxUrl = $container.data('check-address-shipxpert-ajax-url'),
                            $loading = $container.find('.js-check-address__loading'),
                            $error = $container.find('.js-check-address__address-error'),
                            $errorList = $container.find('.js-check-address__address-error-list'),
                            $recommendationsText = $container.find('.js-check-address__recommendations');

                        var data = 'zip=' + $zip.val() + '&' + 'countryCode=' + $country.val() + '&' + 'street=' + $street.val() + '&' + 'number=' + $number.val() + '&' + 'city=' + $city.val();

                        $loading.attr('hidden', null);

                        $country.parsley().removeError('forcederror', {updateClass: true});
                        $zip.parsley().removeError('forcederror', {updateClass: true});
                        $city.parsley().removeError('forcederror', {updateClass: true});
                        $number.parsley().removeError('forcederror', {updateClass: true});
                        $street.parsley().removeError('forcederror', {updateClass: true});

                        pendingRequestAddress = $.ajax(ajaxUrl, {
                            dataType: 'json',
                            data: data,
                            cache: false,
                            headers: {Ajax: 1, Format: 'json'}
                        }).done(function (response) {
                            if (response.success) {
                                $error.attr('hidden', 'hidden');
                                $submitBtn.attr('disabled', false)

                            } else {
                                const recommendations = Array.isArray(response.recommendations) ? response.recommendations : [];
                                const firstRecommendation = recommendations.length ? recommendations[0] : null;

                                const setErr = ($el) => $el.parsley().addError('forcederror', {
                                    message: translate('checkAddressError'),
                                    updateClass: true
                                });

                                const errored = [];

                                if (firstRecommendation) {
                                    if (typeof firstRecommendation.scoreStreet === 'number' && firstRecommendation.scoreStreet < 1) {
                                        setErr($street); errored.push($street);
                                    }
                                    if (typeof firstRecommendation.scoreHouseNo === 'number' && firstRecommendation.scoreHouseNo < 1) {
                                        setErr($number); errored.push($number);
                                    }
                                    if (typeof firstRecommendation.scoreZip === 'number' && firstRecommendation.scoreZip < 1) {
                                        setErr($zip); errored.push($zip);
                                    }
                                    if (typeof firstRecommendation.scoreCity === 'number' && firstRecommendation.scoreCity < 1) {
                                        setErr($city); errored.push($city);
                                    }
                                    if (firstRecommendation.country && $country.val() && String($country.val()).toUpperCase() !== String(firstRecommendation.country).toUpperCase()) {
                                        setErr($country); errored.push($country);
                                    }

                                    if (errored.length === 0) {
                                        setErr($street); errored.push($street);
                                    }
                                } else {
                                    setErr($country);
                                    setErr($zip);
                                    setErr($street);
                                    setErr($number);
                                    setErr($city);
                                    errored.push($street);
                                }
                                if (response.recommendations) {
                                    // console.log('length', response.recommendations.length);
                                    $errorList.empty();
                                    if (response.recommendations.length === 0) {
                                        $recommendationsText.attr('hidden', true);
                                        $errorList.append(
                                            `<li class="font-bold">${translate('noRecommendations')}</li>`
                                        );
                                    } else {
                                        $recommendationsText.attr('hidden', false);
                                        response.recommendations.forEach(function (address) {
                                            $errorList.append(
                                                '<li>' +
                                                '<div class="check-address__recommendation-wrapper">'+
                                                '<span class="check-address__recommendation-text">' +
                                                address.street + ' ' +
                                                address.houseNo + ', ' +
                                                address.zip + ' ' +
                                                address.city + ', ' +
                                                address.country + '</span>' +
                                                `<div class="js-check-address__recommendation btn btn-outline" 
                                                data-address-street="${address.street}" 
                                                data-address-houseno="${address.houseNo}" 
                                                data-address-zip="${address.zip}" 
                                                data-address-city="${address.city}" 
                                                data-address-country="${address.country}"> ${translate('useThisAddress')}` +
                                                '</div>' +
                                                '</div>' +
                                                '</li>');
                                        });
                                    }
                                } else {
                                    $recommendationsText.attr('hidden', true);
                                    $errorList.empty();
                                    $errorList.append(
                                        `<li class="font-bold">${translate('noRecommendations')}</li>`
                                    );
                                }

                                    $error[0].style.scrollMarginBottom = '30px';
                                   // console.log('scoll',$error[0]);
                                    $error[0].scrollIntoView({
                                        behavior: "smooth",
                                        block: "end",
                                    });

                                    $container.find('.js-check-address__use-anyway').on('click', function () {
                                        $container.closest('form').parsley().reset();
                                        $error.attr('hidden', 'hidden');
                                        $submitBtn.attr('disabled', false);
                                        useAnyway = true;
                                        localStorage.setItem('useAnyway', 'true');
                                        return useAnyway;
                                    });

                                    $container.find('.js-check-address__recommendation').on('click', function () {
                                        let data = getPrefixedDataSet('address', $(this));
                                        $street.val(data.street);
                                        $number.val(data.houseno).change();
                                        $zip.val(data.zip);
                                        $city.val(data.city);
                                        $country.val(data.country);

                                        validate($street);
                                    });
                                    
                                    $error.attr('hidden', null);
                                    $submitBtn.attr('disabled', true);

                                    const $trackField = (typeof errored !== 'undefined' && errored[0]) ? errored[0] : $street;
                                    let data = {
                                        "datalayer": {
                                            "event": "error",
                                            "error_field": $trackField.attr('name'),
                                            "error_message": translate('checkAddressError')
                                        }
                                    }
                                    trackEvent(data, {debug: true});
                                }
                                $loading.attr('hidden', 'hidden');
                            }

                        ).fail(function (jqXHR, textStatus, errorThrown) {
                            if (textStatus !== 'abort') {
                                // $error.attr('hidden', null);
                                console.error(textStatus, errorThrown, jqXHR);
                            }
                        }).always(function () {
                            $loading.attr('hidden', 'hidden');
                            pendingRequest = null;
                        });
                    }
                })
            }
        }
    });
}
